/**
 * Связь задачи с сущностью CRM — клиентом, сделкой или агентом (DEV-1614).
 *
 * Задачи по сделкам и клиентам заводит не человек, а сама CRM: они приезжают
 * в трекер мостом и несут тип сущности и её идентификатор. Открыв такую задачу,
 * первым делом хотят посмотреть на сделку — а идти к ней приходилось поиском по
 * CRM, потому что в карточке от связи не было ни следа.
 *
 * Названия сущности трекер не знает и знать не должен: он не ходит в CRM за
 * данными, у него есть только тип и uuid. Поэтому в строке стоит тип и начало
 * идентификатора — тот же кусок, что виден в адресе карточки CRM.
 */
import type { V1EntityType } from '@/api/clients/tracker-issue'

/** Куда ведёт связь: раздел CRM и как называть сущность в подписи */
const ROUTES: Partial<Record<V1EntityType, { path: string; kind: string }>> = {
  ENTITY_TYPE_DEAL: { path: 'deals', kind: 'deal' },
  ENTITY_TYPE_CLIENT: { path: 'clients', kind: 'client' },
  ENTITY_TYPE_AGENT: { path: 'agents', kind: 'agent' },
}

/** Адрес CRM. Дефолт — dev: локальная разработка не должна вести в прод. */
const CRM_URL = (import.meta.env.VITE_CRM_URL || 'https://crm.vpit.dev').replace(/\/+$/, '')

export interface CrmLink {
  /** Ключ для подписи: deal, client или agent */
  kind: string
  /** Начало идентификатора — столько же, сколько человек читает глазами */
  shortId: string
  url: string
}

export const crmLink = (entityType: V1EntityType | '', entityId: string): CrmLink | null => {
  const route = entityType ? ROUTES[entityType] : undefined

  if (!route || !entityId) return null

  return {
    kind: route.kind,
    shortId: entityId.slice(0, 8),
    url: `${CRM_URL}/dashboard/${route.path}/${entityId}`,
  }
}
